// dev
export const devConfig = {
    backendUrl: 'https://api-dev.lionsfloor.com/rewards',
    filesBase: '/files',
    localStorageKey: 'lionsfloor-rewards',
    tokenizationBaseUrl: "https://tokenization-form-dev.synswi.com",
    loginUrl: "/login",
    validateSessionUrl: "/validate-session",
    getItemsPath: "/items",
    paymentInstrumentsUrl: "/payment-instruments",
    accountId: "acc-8c969310-ee35-4d6b-8b76-9ec8690dbc36",
    paymentCryptoKey: import.meta.env.VITE_PAYMENT_INSTRUMENT_SECRET || "rewards-portal-dev",
}
// local
export const localConfig = {
    backendUrl: 'http://localhost:8080/rewards',
    filesBase: '/files',
    localStorageKey: 'lionsfloor-rewards',
    tokenizationBaseUrl: "https://tokenization-form-dev.synswi.com",
    loginUrl: "/login",
    validateSessionUrl: "/validate-session",
    getItemsPath: "/items",
    paymentInstrumentsUrl: "/payment-instruments",
    accountId: "acc-8c969310-ee35-4d6b-8b76-9ec8690dbc36",
    paymentCryptoKey: import.meta.env.VITE_PAYMENT_INSTRUMENT_SECRET || "rewards-portal-dev",
}
export const prodConfig = {
    backendUrl: 'https://api.lionsfloor.com/rewards',
    filesBase: '/files',
    localStorageKey: 'lionsfloor-rewards',
    tokenizationBaseUrl: "https://tokenization-form-dev.synswi.com",
    loginUrl: "/login",
    validateSessionUrl: "/validate-session",
    getItemsPath: "/items",
    paymentInstrumentsUrl: "/payment-instruments",
    accountId: "acc-2acffb81-2b1c-4e20-ade7-03aeaa5593aa",
    paymentCryptoKey: import.meta.env.VITE_PAYMENT_INSTRUMENT_SECRET || "rewards-portal-dev",
}

let env = import.meta.env.VITE_ENV;
console.log('env', env || "dev");

export const config = env === 'prod' ? prodConfig : env === 'local' ? localConfig : devConfig;
// prod
// export const config = {
//     backendUrl: 'https://api.lionsfloor.com/customer-portal',
//     localStorageKey: 'lionsfloor-customer-portal-production',
//     tokenizationBaseUrl: "https://tokenization-form.synswi.com",
//     loginUrl: "/login",
//     validateSessionUrl: "/validate-session",
//     paymentInstrumentsUrl: "/payment-instruments",
//     getShippingAddressesUrl: "/shipping-addresses",
//     getItemsPath: "/items",
//     payinvoiceUrl: "/pay-invoice",
//     accountId: "acc-2acffb81-2b1c-4e20-ade7-03aeaa5593aa"
// }
